import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import MegaMenu from "./MegaMenu";

const Navbar = () => {
  const [click, setClick] = useState(false);

  const [mobileProductOpen, setMobileProductOpen] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <nav className='navbar'>
      <div className='navbar-container'>
        <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
          VETRIEQ
        </Link>
        <div className='menu-icon' onClick={handleClick}>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </div>
        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          
          {click && (
  <div className="mobile-close" onClick={closeMobileMenu}>
    <i className="fas fa-times"></i>
  </div>
)}
          <li className='nav-item'>
            <Link to='/' className='nav-links' onClick={closeMobileMenu}>Home</Link>
          </li>
          <li className='nav-item'>
            <Link to='/about' className='nav-links' onClick={closeMobileMenu}>About</Link>
          </li>
  
            {/* <li className="nav-item nav-item-dropdown">
  <Link
    to="/products"
    className="nav-links"
    onClick={(e) => {
      if (window.innerWidth <= 960) {
        e.preventDefault(); // stop navigation
        setMobileProductOpen(!mobileProductOpen);
      }
    }}
  >
    Products
  </Link>

  <div className={mobileProductOpen ? "mega-wrapper open" : "mega-wrapper"}>
    <MegaMenu closeMobileMenu={closeMobileMenu} />
  </div>
</li> */}

<li className="nav-item nav-item-dropdown">

  <div
    className="nav-links mobile-products-toggle"
    onClick={() => {
      if (window.innerWidth <= 960) {
        setMobileProductOpen(!mobileProductOpen);
      }
    }}
  >
    Products
    <span className={mobileProductOpen ? "dropdown-arrow open" : "dropdown-arrow"}>
      ▽
    </span>
  </div>

  <div className={mobileProductOpen ? "mega-wrapper open" : "mega-wrapper"}>
    <MegaMenu closeMobileMenu={closeMobileMenu} />
  </div>

</li>




    


          <li className='nav-item'>
            <Link to='/certification' className='nav-links' onClick={closeMobileMenu}>Certifications</Link>
          </li>

          <li className='nav-item'>
            <Link to='/payment' className='nav-links' onClick={closeMobileMenu}>Payment Terms</Link>
          </li>

          <li className='nav-item'>
            <Link to='/contactus' className='nav-links' onClick={closeMobileMenu}>Contact</Link>
          </li>

          <li className='nav-item'>
            <Link to='/' className='nav-links' onClick={closeMobileMenu}>Blog</Link>
          </li>

        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
